import {api} from "./index";
import {PageRequest, PageResponse} from "../../shared/types/page";
import {
    Lesson,
    LessonBulkCreateRequest,
    LessonCreateRequest,
    LessonStructureResponse,
    LessonStudentView,
    LessonUpdateRequest
} from "../../shared/types/lesson";

export const getAllLessonsStudentFetch = async (
    pageRequest: PageRequest
): Promise<PageResponse<LessonStudentView>> => {
    const response = await api.post<PageResponse<LessonStudentView>>(
        `/views/lessons/students/paginate`,
        pageRequest
    );
    return response.data;
};

export const getAllLessonsFetch = async (
    pageRequest: PageRequest
): Promise<PageResponse<Lesson>> => {
    const response = await api.post<PageResponse<Lesson>>(
        `/lessons/paginate`,
        pageRequest
    );
    return response.data;
};

export const bulkCreateLessonsFetch = async (
    request: LessonBulkCreateRequest
): Promise<number[]> => {
    const response = await api.post<number[]>(
        '/structure/lessons/bulk',
        request
    );
    return response.data;
};

export const createLessonsFetch = async (
    request: LessonCreateRequest
): Promise<number> => {
    const response = await api.post<number>(
        '/structure/lessons',
        request
    );
    return response.data;
};

export const loadLessonStructureByIdFetch = async (
    id: number
): Promise<LessonStructureResponse> => {
    const response = await api.get<LessonStructureResponse>(
        `/structure/lessons/${id}`
    );
    return response.data
};

export const updateLessonStructureByIdFetch = async (
    id: number, data: LessonUpdateRequest
): Promise<number> => {
    return api.patch(`/structure/lessons/${id}`, data).then(res => res.data);
};

export const deleteLessonStructureByIdFetch = async (
    id: number
): Promise<number> => {
    return api.delete(`/structure/lessons/${id}`).then(res => res.data);
};